import { render } from "./tab-learn-word.vue?vue&type=template&id=61a0fbf4"
import script from "./tab-learn-word.vue?vue&type=script&lang=js"
export * from "./tab-learn-word.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__